import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserSantanderOperationLimit } from '../../models/user-santander-operation-limit.model';
import { BackendService } from '../backend/backend.service';

@Injectable({ providedIn: 'root' })
export class UserSantanderService {
  constructor(private dataService: BackendService) { }

  /**
   * Busca o limite operacional Santander do usuário
   *
   * @param cblcId - ID CBLC do usuário
   * @returns Observable com o limite operacional ou null se o usuário não possui limite
   *
   * @example
   * this.userSantanderService.getSantanderOperationalLimit('123456')
   *   .subscribe(limit => {
   *     if (limit) {
   *       console.log('Has integrated:', limit.hasIntegrated);
   *     }
   *   });
   */
  public getSantanderOperationalLimit(
    cblcId: string
  ): Observable<UserSantanderOperationLimit> {
    const route = `operational-limit/user-lo/${cblcId}`;

    return this.dataService.get<{ hasValue: boolean; value?: any }>(route).pipe(
      map((response) => {
        if (!response.hasValue) {
          //Usar para simular retorno da API
          // return new UserSantanderOperationLimit({
          //   hasIntegrated: true,
          //   accept: false,
          // });
          return new UserSantanderOperationLimit({});
        }

        return UserSantanderOperationLimit.fromJson(response.value);
      })
    );
  }
}
